import { createFileRoute } from '@tanstack/react-router';

import ProductRevisionsPage from '@/components/products/specific/revisions/Page';

export const Route = createFileRoute('/products/$id/revisions')({
	component: ProductRevisionsPage,
});
